<template>
  <div>
    <myHeader></myHeader>
    <div class="web-body">
      <div class="about">
        <my-banner :Mytype="'recruitment'"></my-banner>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
  import banner from './banner'
  import myFooter from './myFooter';
  import myHeader from './myHeader';

  export default {
    name: "recruitment",
    components: {
      'my-banner': banner, myFooter, myHeader
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/recruitment.vue